import $ from "jquery";
import {
    isString,
    isArray,
    isFunction,
    deepClone,
    deepMixin,
    tree as buildTree,
    getWindowSize
} from "../../../funcs";
import RowsStorage from "../../../classes/storage/RowsStorage";
import Menu from "./Menu";
import Backbone from "backbone";
import ContextMenuView from "../../../classes/ContextMenuView";
import langDictionary from "../../../classes/lang/init";


const MENU = RowsStorage.get("MENU");
const SETTINGS = RowsStorage.get("SETTINGS");


const MainMenu = Menu.extend("MainMenu", {

    init() {
        MainMenu.__super__.init.apply(this, arguments);

        this.rights = system.rights.getMenuRights();
        this.listenTo(MENU, "entity:change", this.onChangeMenuRows.bind(this));
        this.listenTo(system, "lang:texts:change lang:other:change", this.onChangeMenuRows.bind(this));

        this.initModals();
        this.initSubMenus();

        // загрузка моделей меню с сервера
        this.load(() => {
            // отрисовка моделей
            this.view.render();

            this.trigger("ready");
            this._ready = true;
        });
    },

    ready(callback) {
        if ( this._ready ) {
            setTimeout(callback, 4);
        } else {
            this.on("ready", callback);
        }
    },

    initModals() {
        this._modals = {};
    },


    async exclude() {
        const settings = await SETTINGS.get(1);

        const excludeCondition = [];


        const isRolisEvent = settings.get("ROLIS_EVENT_INTEGRATION_ENABLE");
        if ( !isRolisEvent ) {
            excludeCondition.push(["APP", "!=", "rolis_event"]);
            excludeCondition.push(["APP", "!=", "rolis_subscription"]);
        }


        const isRolisEdi = settings.get("ROLIS_EDI_INTEGRATION_ENABLE");
        if ( !isRolisEdi ) {
            excludeCondition.push(["APP", "!=", "rolis_edi"]);
        }


        const join = (arr, cond) => arr
            .reduce((acc, item) => acc.concat([item, cond]), [])
            .slice(0, -1);

        return excludeCondition.length
            ? [["APP", "is", "null"], "or", join(excludeCondition, "and")]
            : null;
    },

    async load(callback) {
        if ( !isFunction(callback) ) {
            callback = function() {
            };
        }

        await MENU.get({
            sorts: [{ SORT: 1 }],
            limit: "all",
            filter3: await this.exclude()
        });

        this.items.reset();
        this._resetModels();

        callback();
    },

    _resetModels() {
        let models = deepClone(MENU.collection.models);

        models = models.sort((modelA, modelB) =>
            modelA.get("SORT") - modelB.get("SORT")
        );

        this.items.reset();

        this.modelById = {};
        let rows = models.map((model) => {
            let id = model.id;
            this.modelById[id] = model;

            return { id, parent: model.get("ID_PARENT") };
        });

        this.tree = buildTree(rows, "id", "parent");
        let items = this.makeItems(this.tree.root.elems);

        this.items.add(items);
    },

    makeItem(elem) {
        let id = elem.id;
        let menuItemModel = this.modelById[id];
        if ( !menuItemModel ) {
            return;
        }

        let isDivider = menuItemModel.get("IS_DIVIDER") == 1;

        const name = menuItemModel.getText("NAME");
        const translatedName = langDictionary.getAppTitle(name);

        let item = {
            id: menuItemModel.id,
            icon: menuItemModel.get("ICON"),
            app: menuItemModel.get("APP"),
            runName: menuItemModel.get("APP"),
            name: translatedName || name,
            className: isDivider ? "divider" : ""
        };

        let app = menuItemModel.get("APP");
        if ( app ) {
            item.app = app;
            item.action = "app";

            const translatedApp = langDictionary.getAppTitle(app);

            if ( translatedApp && translatedApp !== app ) {
                item.name = translatedApp;
            }

            if ( !item.name || item.name == item.app ) {
                item.name = langDictionary.getAppTitle(item.app);
            }
        }

        let hasRight = this.rights.checkItem(menuItemModel.id);
        let hasAllowedChild = false;
        if ( !hasRight ) {
            hasAllowedChild = elem.children.getAll().some((childElem) =>
                this.rights.checkItem(childElem.id)
            );
            hasRight = hasAllowedChild;
        }

        if ( !hasRight && !isDivider ) {
            item.display = "none";
        }

        let subMenu = this.makeItems(elem.children.elems);
        if ( subMenu.length ) {
            item.subMenu = subMenu;
            item.action = "subMenu";
        }

        return item;
    },

    makeItems(elems) {
        let items = [];
        const isAdminUser = (system.user.id == 1);

        elems.forEach((elem) => {
            let item = this.makeItem(elem);
            if ( !item ) {
                return;
            }

            // пункт меню "Перевести логось" доступен только под пользователем admin
            const isTranslationLogosItem = (item.app == "logos_lang_translation");
            if (
                isTranslationLogosItem
                && !isAdminUser
            ) {
                return;
            }

            items.push(item);
        });

        return items;
    },

    on_go(model) {
        if ( model.get("action") != "subMenu" ) {
            this.closeSubMenus();
        }
    },

    initSubMenus() {
        this._subMenus = {};
    },

    on_subMenu(model, e) {

        let id = model.id;
        let subMenu = model.get("subMenu");

        if ( !isArray(subMenu) ) {
            return;
        }

        let data = model.get("data") || {};
        let links = deepClone(data.links);

        subMenu = deepClone(subMenu);

        if ( links ) {

            links = links.map((link) =>
                deepMixin(link, link.data)
            );
            subMenu = subMenu.concat(links);
        }

        if ( !this._subMenus[id] ) {
            subMenu.forEach((item) => {
                if ( !item ) {
                    return;
                }

                if ( item.subMenu ) {
                    if ( isString(item.className) ) {
                        item.className += " has-subs";
                    } else {
                        item.className = "has-subs";
                    }
                }
            });


            let windowHeight = getWindowSize().height;
            let maxHeight = windowHeight - 5;

            let collection = new Backbone.Collection(subMenu);
            let parentMenu = this._subMenus[model.get("_parentId")];
            let subMenuView = new ContextMenuView({
                addClassName: "sub-main-menu theme-background-color MainMenuAppContext",
                maxHeight,
                parentMenu,
                collection,
                zIndex: 9999999999
            });
            if ( parentMenu ) {
                parentMenu.childMenu = subMenuView;
            }
            this._subMenus[id] = subMenuView;

            subMenuView.render();
            subMenuView.on("itemClick", (e, model) => {
                this.trigger("go " + model.get("action"), model, e);
            });
        }

        let $el = $(e.target);
        let $menuItem = $el.is("[mid]") ? $el : $el.parents("[mid]");
        let $icon = $menuItem.find(".menu-item-icon");
        if ( $icon.length === 0 ) {
            $icon = $el.parents("li");
        }
        let $mainMenuView = this.view.$el;
        let $visibleElement = $mainMenuView.hasClass("closed") || !$menuItem.length
            ? $icon
            : $menuItem;

        if ( $visibleElement[0] ) {
            let rect = $visibleElement[0].getBoundingClientRect();

            this._subMenus[id].moveTo(rect.left + rect.width, rect.top - 5);
        }

        this._subMenus[id].show();
    },

    closeSubMenus() {
        for (let id in this._subMenus) {
            this._subMenus[id].hide();
        }
        this.view.closeMenu();
    },

    focusEnter($tab) {
        $tab.find("[mid]:first").click();
    },

    on_app(itemModel) {
        let runName = itemModel.get("app");

        if ( runName ) {
            const title = itemModel.get("name");

            // @see AppManager.js
            // @see BaseApp.js
            localStorage.setItem("lastRun", runName);

            system.run({ app: runName, title });
        }
        else {
            const params = deepClone(itemModel.attributes);

            params.title = itemModel.get("name");
            params.runName = itemModel.get("runName");

            system.apps.run(params);
        }
    },

    onChangeMenuRows() {
        this._resetModels();

        const toDestroy = [];
        for (let id in this._subMenus) {
            const menuItem = this.items.get(id);
            if ( !menuItem ) {
                toDestroy.push(id);
                continue;
            }

            const subMenuItems = deepClone(menuItem.get("subMenu") || []);

            subMenuItems.forEach((item) => {
                if ( !item ) {
                    return;
                }

                if ( item.subMenu ) {
                    if ( isString(item.className) ) {
                        item.className += " has-subs";
                    } else {
                        item.className = "has-subs";
                    }
                }
            });

            const subMenuView = this._subMenus[id];
            subMenuView.collection.reset();
            subMenuView.collection.add(subMenuItems);
            subMenuView.render();
        }

        for (const id of toDestroy) {
            const subMenuView = this._subMenus[ id ];
            try {
                subMenuView.destroy();
            } catch (err) {
                console.log(err);
            }
            delete this._subMenus;
        }

        this.view.render();
        this.view.itemsView.render();
        this.view.$el.data("plugin_tinyscrollbar").update();
    }
});

export default MainMenu;
